// src/utils/api.js

const BASE_URL = process.env.REACT_APP_API_BASE_URL_ADMIN;

// Utility function to get auth headers
const getHeaders = (isJson = true) => {
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
    };
    if (isJson) headers['Content-Type'] = 'application/json';
    return headers;
};

// GET by ID

export const GET_LIST = async (endpoint, queryParams = {}) => {
    try {
        const queryString = new URLSearchParams(queryParams).toString();
        const url = `${BASE_URL}${endpoint}${queryString ? `?${queryString}` : ''}`;

        const response = await fetch(url, {
            method: 'GET',
            headers: getHeaders(),
        });

        return await response.json();
    } catch (error) {
        console.error('GET_LIST error:', error);
        throw error; // Let calling code handle the error
    }
};


// GET by ID
export const GET_LISTBYID = async (endpoint, id = '') => {
    try {
        const response = await fetch(`${BASE_URL}${endpoint}${id ? `/${id}` : ''}`, {
            method: 'GET',
            headers: getHeaders(),
        });
        return await response.json();
    } catch (error) {
        console.error('GET_LISTBYID error:', error);
        throw error;
    }
};

// POST (Save)
export const SAVE = async (endpoint, data) => {
    try {
        const response = await fetch(`${BASE_URL}${endpoint}`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify(data),
        });

        const responseData = await response.json();
        return {
            ok: response.ok,
            status: response.status,
            data: responseData,
        };
    } catch (error) {
        console.error('SAVE error:', error);
        throw error;
    }
};

// PUT (Update)
export const UPDATE = async (endpoint, data) => {
    try {
        const response = await fetch(`${BASE_URL}${endpoint}`, {
            method: 'PUT',
            headers: getHeaders(),
            body: JSON.stringify(data),
        });
        const responseData = await response.json();
        return {
            ok: response.ok,
            status: response.status,
            data: responseData,
        };
    } catch (error) {
        console.error('UPDATE error:', error);
        throw error;
    }
};

export const UPDATE2 = async (endpoint, data) => {
    try {
        const response = await fetch(`${BASE_URL}${endpoint}`, {
            method: 'PATCH',
            headers: getHeaders(),
            body: JSON.stringify(data),
        });
        const responseData = await response.json();
        return {
            ok: response.ok,
            status: response.status,
            data: responseData,
        };
    } catch (error) {
        console.error('UPDATE error:', error);
        throw error;
    }
};

// DELETE by ID
export const DELETE_DATA = async (endpoint, id) => {
    try {
        const response = await fetch(`${BASE_URL}${endpoint}/${id}`, {
            method: 'DELETE',
            headers: getHeaders(),
        });
        return response;
    } catch (error) {
        console.error('DELETE_DATA error:', error);
        throw error;
    }
};

// File Download (GET with blob)
export const GET_FILE = async (endpoint, queryParams = {}, fileType = 'csv', filename = 'file') => {
    try {
        const queryString = new URLSearchParams(queryParams).toString();
        const url = `${BASE_URL}${endpoint}${queryString ? `?${queryString}` : ''}`;

        const response = await fetch(url, {
            method: 'GET',
            headers: getHeaders(),
        });

        if (!response.ok) {
            throw new Error(`File download failed: ${response.status}`);
        }

        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = `${filename}.${fileType}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
        console.error('GET_FILE error:', error);
        throw error;
    }
};
